<template>
  <div class="contact-section">
    <div class="container">
      <div class="contact-content">
        <div class="map-section">
          <!-- 使用高德地图瓦片服务 -->
          <l-map :zoom="15" :center="[34.77, 113.86]" style="width: 100%; height: 400px; border-radius: 8px;">
            <l-tile-layer url="http://webrd0{s}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}" :subdomains="['1', '2', '3', '4']"></l-tile-layer>
            <l-marker :lat-lng="[34.77, 113.86]">
              <l-popup>河南省智睿研成评价技术中心</l-popup>
            </l-marker>
          </l-map>
        </div>
        <div class="info-section">
          <h2>河南省智睿研评成果评价技术中心</h2>
          <div class="contact-item">
            <div class="u-font-14 cl_zs">服务热线：</div>
            <div class="u-font-20 cl_zs fw_600">{{phone}}</div>
          </div>
          <div class="contact-item">
            <span class="u-font-16 cl_333">地址：河南省郑州市郑东新区郑开大道71号恒通国际广场5层501室中间户A-67</span>
          </div>
          <div class="qrcode-section">
            <img :src="httphosts+code" alt="二维码">
            <div class="postal-code">微信公众号</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { contactInfoConfig } from '@/api/index.js'
import { httphosts } from '@/utils/global'

import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'

// 修复标记图标问题
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png'
})

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  },
  data() {
    return {
      httphosts: httphosts,
      phone: '',
      code: ''
    }
  },
  mounted() {
    this.getContactInfo()
  },
  methods: {
    getContactInfo() {
      contactInfoConfig().then(res => {
        if (res.code === 1) {
          this.phone = res.data.contact_info_hotline.value
          this.code = res.data.contact_info_official_account.value
        }
      })
    }
  }
}
</script>

<style>
.contact-section{
  padding: 60px 0;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.contact-content{
  display: flex;
  gap: 40px;
  padding: 30px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}
.map-section {
  flex: 1;
  min-width: 400px;
}
.map-section img {
  width: 100%;
  height: auto;
  border-radius: 8px;
}
.info-section {
  flex: 1;
  min-width: 300px;
  padding: 20px 0;
}
.info-section h2 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 30px;
  color: #333;
}
.contact-item {
  margin-bottom: 20px;
  line-height: 1.5;
}
.contact-item .label {
  font-weight: bold;
  color: #333;
  margin-right: 10px;
}
.contact-item .value {
  color: #666;
}
.qrcode-section {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.qrcode-section img {
  width: 110px;
  height: 110px;
}
.postal-code {
  text-align: center;
  width: 110px;
  font-size: 14px;
  color: #333333;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .contact-content {
    flex-direction: column;
  }
  .map-section {
    min-width: 100%;
  }
  .info-section {
    min-width: 100%;
  }
  .qrcode-section {
    justify-content: center;
  }
}
</style>